module.exports = {
      id: "lifestyle-usage",
      viewBox: "0 0 24.217 32.155",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#lifestyle",
      toString: function () {
        return this.url;
      }
    }